import React from 'react';
import cx from 'classnames';

import { Pressable, PressableProps } from '../pressable';

export interface ChipProps extends PressableProps {
  /** Sits before the label, in the muted text colour. */
  icon?: React.ReactNode;
  /** `overlay` floats over a picture: dark, small, square-ish — «Увеличить» on an image. */
  tone?: 'default' | 'overlay';
}

const toneClasses = {
  default:
    'gap-1.5 rounded-full border border-line bg-surface px-3 py-1.5 text-ui-xs-strong text-ink shadow-control hover:border-line-strong hover:bg-surface-muted',
  overlay: 'gap-1 rounded-chip bg-black/60 px-2 py-1 text-ui-xs text-white hover:bg-black/70 md:text-ui',
};

/** A small white pill that opens something — a report of a session, a saved filter. Quieter than a `Button`. */
export const Chip = ({ icon, tone = 'default', className, children, ...rest }: ChipProps) => (
  <Pressable
    className={cx('inline-flex items-center whitespace-nowrap transition-colors', toneClasses[tone], className)}
    {...rest}
  >
    {icon && <span className={cx('inline-flex shrink-0', tone === 'default' && 'text-ink-subtle')}>{icon}</span>}
    {children}
  </Pressable>
);
